<a
    [href]="loginUrl"
    class="message--module-inactive message--module-inactive--outlook"
    (click)="activeModal.dismiss()">
    <strong>You are not logged in with Outlook.</strong>
    <small>Click to connect your account.</small>
</a>
